<script lang="jsx">
import { computed, defineComponent, ref, toRef, watch, onMounted, nextTick, onUpdated, watchEffect, watchPostEffect } from '@nuxtjs/composition-api';
import { useMounted } from '@vueuse/core';
// import { render } from 'less';

const NONE = 0;
const PREPARE = 1;
const WALKING = 2;
const DONE_WITH_ELLIPSIS = 3;
const DONE_WITHOUT_ELLIPSIS = 4;




/**
 *
 * @param {import('vue').VNode} node
 */
function cuttable(node) {
    // const nodeType = node?.elm?.nodeType;
    // return nodeType === 3;
    return !node.isComment && !!node.text
}
/**
 *
 * @param {import('vue').VNode[]} nodeList
 */
function getNodesLen(nodeList = []) {
    let totalLen = 0;
    nodeList.forEach(node => {
        if (cuttable(node)) {
            totalLen += String(node.text).length
        } else {
            totalLen += 1
        }
    })

    return totalLen;
}

const sliceNodes = (nodeList, len) => {

    let currLen = 0;
    const currentNodeList = [];

    for (let i = 0; i < nodeList.length; i += 1) {
        // Match to return
        if (currLen === len) {
            return currentNodeList;
        }

        const node = nodeList[i];
        const canCut = cuttable(node);
        const nodeLen = canCut ? String(node.text).length : 1;
        const nextLen = currLen + nodeLen;

        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            // node.text = String(node.text).slice(0, restLen)
            currentNodeList.push(String(node.text).slice(0, restLen));
            return currentNodeList;
        }

        currentNodeList.push(node);
        currLen = nextLen;
    }

    return currentNodeList;
}

export default defineComponent({
    props: {
        width: Number,
        fontSize: Number,
        enabledMeasure: Boolean,
        rows: Number,
        text: {
            type: Array,
            default: () => []
        }
    },
    setup(props, { slots }) {
        const rows = toRef(props, 'rows')
        const cutLength = ref([0, 0, 0])
        const walkingState = ref(NONE)
        const singleRowHeight = ref(0);

        const singleRowRef = ref();
        const midRowRef = ref();
        const nodeList = computed(() => Array.from(props.text));
        const totalLen = computed(() => getNodesLen(nodeList.value))

        const uid = Date.now();
        const isMounted = useMounted();

        // ======================== Walk ========================
        watch(() => {
            return [props.enabledMeasure, props.width, props.fontSize, props.text, totalLen, props.rows]
        }, () => {
            let len = totalLen.value;
            walkingState.value = PREPARE;
            cutLength.value = [0, Math.ceil(len / 2), len];
        }, {
            immediate: true
        })


        watchPostEffect(() => {
            if (walkingState.value === PREPARE) {
                singleRowHeight.value = singleRowRef.value?.offsetHeight || 0;
            }
        })

        watchPostEffect(() => {
            const [startLen, midLen, endLen] = cutLength.value;
            if (singleRowHeight.value) {
                if (walkingState.value === PREPARE) {
                    const midHeight = midRowRef.value?.offsetHeight || 0;
                    const maxHeight = rows.value * singleRowHeight.value;
                    if (midHeight <= maxHeight) {
                        walkingState.value = DONE_WITHOUT_ELLIPSIS;
                        // TODO: onEllipsis(false)
                    } else {
                        walkingState.value = WALKING;
                    }
                } else if (walkingState.value === WALKING) {
                    if (startLen !== endLen) {
                        const midHeight = midRowRef.value?.offsetHeight || 0;
                        const maxHeight = rows.value * singleRowHeight.value;

                        let nextStartLen = startLen;
                        let nextEndLen = endLen;

                        if (startLen === endLen - 1) {
                            nextEndLen = startLen;
                        } else if (midHeight <= maxHeight) {
                            nextStartLen = midLen;
                        } else {
                            nextEndLen = midLen;
                        }

                        const nextMidLen = Math.ceil((nextStartLen + nextEndLen) / 2);
                        cutLength.value = [nextStartLen, nextMidLen, nextEndLen];
                    } else {
                        walkingState.value = DONE_WITH_ELLIPSIS;
                        // todo onEllipsis(true)
                    }
                }
            }
        })

        // function syncEllipsis() {
        //     const [startLen, midLen, endLen] = cutLength.value;
        //     if (singleRowHeight.value) {
        //         if (walkingState.value === PREPARE) {
        //             const midHeight = midRowRef.value?.offsetHeight || 0;
        //             const maxHeight = rows.value * singleRowHeight.value;

        //             if (midHeight <= maxHeight) {
        //                 walkingState.value = DONE_WITHOUT_ELLIPSIS;
        //                 // TODO: onEllipsis(false)
        //             } else {
        //                 walkingState.value = WALKING;
        //             }
        //         } else if (walkingState.value === WALKING) {
        //             if (startLen !== endLen) {
        //                 const midHeight = midRowRef.value?.offsetHeight || 0;
        //                 const maxHeight = rows.value * singleRowHeight.value;

        //                 let nextStartLen = startLen;
        //                 let nextEndLen = endLen;

        //                 if (startLen === endLen - 1) {
        //                     nextEndLen = startLen;
        //                 } else if (midHeight <= maxHeight) {
        //                     nextStartLen = midLen;
        //                 } else {
        //                     nextEndLen = midLen;
        //                 }

        //                 const nextMidLen = Math.ceil((nextStartLen + nextEndLen) / 2);
        //                 cutLength.value = [nextStartLen, nextMidLen, nextEndLen];
        //             } else {
        //                 walkingState.value = DONE_WITH_ELLIPSIS;
        //                 // todo onEllipsis(true)
        //             }
        //         }
        //     }
        // }

        const measureStyle = computed(() => ({
            width: `${props.width}px`,
            whiteSpace: 'normal',
            margin: 0,
            padding: 0,
        }));

        return {
            singleRowRef,
            singleRowHeight,
            midRowRef,
            walkingState,
            cutLength,
            measureStyle,

            nodeList,
            totalLen
        }
    },
    render(h) {
        const { enabledMeasure, walkingState, nodeList, width, totalLen, measureStyle } = this;
        const [startLen, midLen, endLen] = this.cutLength;

        let mergedChildren;
        // console.count('render' + this._uid)
        if (!this.enabledMeasure || walkingState !== DONE_WITH_ELLIPSIS) {
            mergedChildren = this.$scopedSlots.default(nodeList, false);
        } else {
            mergedChildren = this.$scopedSlots.default(sliceNodes(nodeList, midLen), midLen < totalLen)
        }

        const renderMeasure = (content, ref, style) => {
            return h('span', {
                style: {
                    position: 'fixed',
                    display: 'block',
                    left: 0,
                    top: 0,
                    zIndex: -9999,
                    visibility: 'hidden',
                    pointerEvents: 'none',
                    // wordBreak: 'break-all',
                    fontSize: Math.floor(this.ellipsisFontSize / 2) * 2,
                    ...style,
                },
                ref
            }, [content]);
        }
        const renderMeasureSlice = (len, ref) => {
            const sliceNodeList = sliceNodes(nodeList, len);
            return renderMeasure(this.$scopedSlots.default(sliceNodeList, true), ref, measureStyle)
        }
        return h('div', {}, [mergedChildren, enabledMeasure && walkingState !== DONE_WITH_ELLIPSIS && walkingState !== DONE_WITHOUT_ELLIPSIS && [

            renderMeasure('lg', el => this.singleRowRef = el, { wordBreak: 'keep-all', whiteSpace: 'nowrap' }),

            walkingState === PREPARE ?
                renderMeasure(this.$scopedSlots.default(nodeList, false), el => this.midRowRef = el, measureStyle) :
                renderMeasureSlice(midLen, el => this.midRowRef = el)
        ]])
    }
})
</script>

<style lang="scss">

</style>
